/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_NoneInputs */

const th_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีการประชุม เริ่มสร้างแล้วผู้ที่คุณเชิญจะได้รับแจ้งทันที`)
};

const en_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No meetings yet. Start one and the people you invite are told straight away.`)
};

const ja_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだミーティングはありません。作成すると招待した人にすぐ通知されます。`)
};

const zh_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有会议。创建一个，受邀者会立即收到通知。`)
};

const es_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay reuniones. Crea una y se avisará al instante a quienes invites.`)
};

const pt_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma reunião ainda. Crie uma e quem você convidar é avisado na hora.`)
};

const id_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pertemuan. Buat satu dan yang diundang akan langsung diberi tahu.`)
};

const fr_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune réunion pour l’instant. Créez-en une et les personnes invitées sont prévenues aussitôt.`)
};

const tl_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang miting. Gumawa ng isa at agad na mababalitaan ang mga inanyayahan.`)
};

const vi_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có cuộc họp nào. Tạo một cuộc và người được mời sẽ được báo ngay.`)
};

const ko_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 회의가 없습니다. 하나 만들면 초대받은 사람에게 바로 알림이 갑니다.`)
};

const de_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Meetings. Leg eines an, und die Eingeladenen werden sofort benachrichtigt.`)
};

const ru_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встреч пока нет. Создайте одну, и приглашённые сразу получат уведомление.`)
};

const tr_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz toplantı yok. Bir tane oluşturun, davet edilenler hemen haber alsın.`)
};

const it_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna riunione. Creane una e gli invitati verranno avvisati subito.`)
};

const pl_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze spotkań. Utwórz jedno, a zaproszeni od razu dostaną powiadomienie.`)
};

const uk_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зустрічей поки немає. Створіть одну, і запрошені одразу отримають сповіщення.`)
};

const hi_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई बैठक नहीं। एक बनाएँ और आमंत्रित लोगों को तुरंत सूचना मिलेगी।`)
};

const ar_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد اجتماعات بعد. أنشئ واحدًا وسيصل المدعوّين إشعار فورًا.`)
};

const ms_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada mesyuarat. Cipta satu dan mereka yang dijemput akan segera dimaklumkan.`)
};

const bn_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও সভা নেই। একটি তৈরি করুন, আমন্ত্রিতরা সঙ্গে সঙ্গে জানবেন।`)
};

const zh_tw2_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無會議。建立一個，受邀者會立刻收到通知。`)
};

const zh_hk2_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無會議。建立一個，受邀者會立刻收到通知。`)
};

const ur_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی ملاقات نہیں۔ ایک بنائیں، مدعو افراد کو فوراً اطلاع مل جائے گی۔`)
};

const fa_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز جلسه‌ای نیست. یکی بسازید تا دعوت‌شدگان بی‌درنگ خبردار شوند.`)
};

const sw_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mikutano bado. Fungua mmoja nao walioalikwa watajulishwa mara moja.`)
};

const nl_meeting_none = /** @type {(inputs: Meeting_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen gesprekken. Maak er een aan en de genodigden horen het meteen.`)
};

/**
* | output |
* | --- |
* | "No meetings yet. Start one and the people you invite are told straight away." |
*
* @param {Meeting_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_none = /** @type {((inputs?: Meeting_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_none(inputs)
	if (locale === "ja") return ja_meeting_none(inputs)
	if (locale === "zh") return zh_meeting_none(inputs)
	if (locale === "es") return es_meeting_none(inputs)
	if (locale === "pt") return pt_meeting_none(inputs)
	if (locale === "id") return id_meeting_none(inputs)
	if (locale === "fr") return fr_meeting_none(inputs)
	if (locale === "tl") return tl_meeting_none(inputs)
	if (locale === "vi") return vi_meeting_none(inputs)
	if (locale === "ko") return ko_meeting_none(inputs)
	if (locale === "de") return de_meeting_none(inputs)
	if (locale === "ru") return ru_meeting_none(inputs)
	if (locale === "tr") return tr_meeting_none(inputs)
	if (locale === "it") return it_meeting_none(inputs)
	if (locale === "pl") return pl_meeting_none(inputs)
	if (locale === "uk") return uk_meeting_none(inputs)
	if (locale === "hi") return hi_meeting_none(inputs)
	if (locale === "ar") return ar_meeting_none(inputs)
	if (locale === "ms") return ms_meeting_none(inputs)
	if (locale === "bn") return bn_meeting_none(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_none(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_none(inputs)
	if (locale === "ur") return ur_meeting_none(inputs)
	if (locale === "fa") return fa_meeting_none(inputs)
	if (locale === "sw") return sw_meeting_none(inputs)
	if (locale === "nl") return nl_meeting_none(inputs)
	return en_meeting_none(inputs)
});